import { getSameAttribute, resetAttribute } from '@/utils/handleData'

export default {
  namespaced: true,
  actions: {
    /********************************************** 系统字段设置 ********************************************************/

    /* ************************岗位职务 *************************/
    // 添加岗位职务
    async addOrgJobTitle({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/template/duties',
          data: data,
          msg: '添加岗位职务成功'
        },
        { root: true }
      )
      return res
    },
    // 删除岗位职务
    async deleteOrgJobTitle({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/template/duties',
          data: { uid: uid },
          msg: '删除岗位职务成功'
        },
        { root: true }
      )
      return res
    },
    // 获取机构下岗位职务
    async getOrgJobTitle({ rootState, dispatch }, uid) {
      var projectUid = uid ? uid : rootState.user.orgValue
      await dispatch(
        'orgFieldsRequest',
        {
          key: 'jobTitle',
          label: 'name',
          value: 'uid',
          childrenKey: 'list',
          url: '/person/template/duties',
          data: { projectUid: projectUid }
        },
        { root: true }
      )
    },
    // 编辑岗位职务
    async editOrgJobTitle({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/template/duties',
          data: data,
          msg: '编辑岗位职务成功'
        },
        { root: true }
      )
      return res
    },

    /* **************工程结构模型************** */

    // 添加工程结构模型
    async addStructureModel({ rootState, rootGetters, dispatch }, data) {
      const orgUid =
        rootGetters['user/orgName'] === '甘肃大鹏鸟科技有限公司'
          ? ''
          : rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/dictionary/model',
          data: Object.assign({}, data, orgUid ? { orgUid: orgUid } : { catalog: 'managed' }),
          msg: '添加工程结构模型成功'
        },
        { root: true }
      )
      return res
    },

    // 删除工程结构模型
    async deleteStructureModel({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/dictionary/model',
          data: { uid: uid },
          msg: '删除工程结构模型成功'
        },
        { root: true }
      )
      return res
    },

    // 获取工程结构模型
    async getStructureModel({ rootState, rootGetters, commit, dispatch }, payload) {
      const system =
        payload && payload.scope === 'system'
      const orgUid = system
        ? ''
        : typeof payload === 'string' && payload
        ? payload
        : rootGetters['user/orgName'] === '甘肃大鹏鸟科技有限公司'
        ? ''
        : rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/dictionary/modellist',
          data: system
            ? { scope: 'system' }
            : orgUid
            ? { orgUid: orgUid }
            : { scope: 'system' }
        },
        { root: true }
      )
      var structureModel = res.data ? res.data : []
      structureModel.forEach((item) => {
        item.fileLists = {}
        if (!item.image) {
          item.picStatus = '无模型图'
          item.fileLists.image = []
        } else {
          item.picStatus = '有模型图'
          commit(
            'pictureSet',
            { key: 'structureModel', value: [item.image] },
            { root: true }
          )
          item.fileLists.image = rootState.pictures.structureModel
        }
        item.sizes = item.sizes || []
        item.sizes.forEach((size, index) => {
          item['key' + (index + 1)] = size.key
          item['label' + (index + 1)] = size.label
          item['type' + (index + 1)] = size.type
          item['value' + (index + 1)] = size.value
          item['unit' + (index + 1)] = size.unit
          size.info =
            size.label + '：' + size.value + (size.unit ? size.unit : '')
        })
        item.info = getSameAttribute(item.sizes, 'info', '；').joinString
      })
      structureModel = resetAttribute(structureModel, 'name', 'uid')
      commit(
        'orgFieldsSet',
        { key: 'structureModel', value: structureModel },
        { root: true }
      )
    },

    // 编辑工程结构模型
    async editStructureModel({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/dictionary/model',
          data: data,
          msg: '编辑工程结构模型成功'
        },
        { root: true }
      )
      return res
    },

    async syncStructureModel({ rootState, dispatch }, mode) {
      const orgUid = rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url:
            '/organize/dictionary/model/sync?orgUid=' +
            encodeURIComponent(orgUid || '') +
            '&mode=' +
            encodeURIComponent(mode || 'fill'),
          data: {},
          msg: true
        },
        { root: true }
      )
      return res
    },

    async syncOrgJobTitle({ rootState, dispatch }, mode) {
      const projectUid = rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url:
            '/person/template/duties/sync?projectUid=' +
            encodeURIComponent(projectUid || '') +
            '&mode=' +
            encodeURIComponent(mode || 'fill'),
          data: {},
          msg: true
        },
        { root: true }
      )
      return res
    },

    /* ************************合同类型 *************************/
    // 获取机构下合同类型及模板
    async getOrgContractType({ dispatch }, uid) {
      await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/rule/templatecontract/find',
          data: { uid: uid }
        },
        { root: true }
      )
    }
  }
}
